/* eslint-disable comma-dangle */
/**
 * @param {object} Drupal - The Drupal object.
 * @param {Function} once - The once function.
 */
(function (Drupal, once) {
  'use strict';

  /**
   * Initializes the stop numbers for each chapter in the itinerary.
   *
   * This function finds all chapter elements within the itinerary content,
   * counts the total number of chapters/stops, and updates each chapter's
   * itinerary stop text to show its position (e.g., "Stop 1 of 5").
   *
   * @return {void}
   */
  function initializeStops() {
    const itineraryContent = document.querySelector('.itinerary-content');
    if (itineraryContent) {
      const stops = itineraryContent.querySelectorAll(
        '.chapter .chapter__itinerary-stop'
      );
      const totalStops = stops.length;
      stops.forEach((stop, index) => {
        stop.textContent = `Stop ${index + 1} of ${totalStops}`;
      });
    }
  }

  Drupal.behaviors.chapter = {
    attach: function (context) {
      initializeStops();
    },
  };
})(Drupal, once);
